// import { z } from 'zod'
// import noLeadingSpaces from '../../../../src/utilities/noLeadingSpaces'

// export const grievanceSchema = z.object({
//   name: z
//     .string({ invalid_type_error: 'Required.' })
//     .min(1, { message: 'Required.' })
//     .max(25, { message: 'Maximum 25 characters allowed.' })
//     .refine(noLeadingSpaces, {
//       message: 'Leading spaces are not allowed.',
//     }),
//   phone: z
//     .string()
//     .nullable()
//     .transform((value) => (value === null ? '' : value))
//     .refine(
//       (value) => {
//         return (
//           (/^\d{10}$/.test(value) &&
//             parseInt(value, 10) !== 0 &&
//             !/\+/.test(value)) ||
//           value === ''
//         )
//       },
//       {
//         message: 'Enter a valid 10-digit mobile number.',
//       }
//     )
//     .optional(),

//   email: z
//     .string()
//     .min(5, { message: 'Required.' })
//     .superRefine((value, ctx) => {
//       if (value !== '') {
//         if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
//           ctx.addIssue({
//             code: z.ZodIssueCode.custom,
//             message: 'Invalid email format.',
//           })
//         }
//       }
//     })
//     .refine(noLeadingSpaces, {
//       message: 'Leading spaces are not allowed.',
//     }),

//   message: z
//     .string({ invalid_type_error: 'Required.' })
//     .min(1, { message: 'Required.' })
//     .max(1000, { message: 'Maximum 1000 characters allowed.' })
//     .refine(noLeadingSpaces, {
//       message: 'Leading spaces are not allowed.',
//     }),
// })

// export type GrievanceSchema = z.infer<typeof grievanceSchema>

import { z } from 'zod'
import noLeadingSpaces from '../../../utilities/noLeadingSpaces'

export const registrationSchema = z.object({
  first_name: z
    .string()
    .min(1, 'First name is required')
    .max(50)
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),

  last_name: z
    .string()
    .min(1, 'Last name is required')
    .max(50)
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),

  email: z
    .string()
    .min(5, { message: 'Email is required' })
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' })
    .refine((value) => /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value), {
      message: 'Invalid email format.',
    }),

  phone: z
    .string()
    .min(10, { message: 'Enter a valid 10-digit mobile number' })
    .max(10, { message: 'Enter a valid 10-digit mobile number' })
    .refine((value) => /^\d{10}$/.test(value) && parseInt(value) !== 0, {
      message: 'Enter a valid 10-digit mobile number',
    }),

  message: z
    .string()
    .min(1, 'Message is required')
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),
})

export type RegistrationSchema = z.infer<typeof registrationSchema>
